import React from 'react';
import { createRoot } from 'react-dom/client';
import { Route, BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from 'store/store';
import App from 'app/App';
import { AuthServiceProvider } from 'components/context/authServiceContext';
import MockAuthService from 'services/auth/MockAuthService';
import AuthService from 'services/auth/AuthService';
import { StyledEngineProvider, ThemeProvider, createTheme } from '@mui/material';
import { ruRU as dateRuRU} from '@mui/x-date-pickers/locales';
import { ruRU as coreRuRU } from '@mui/material/locale';
import { ruRU as dataGridRuRU } from '@mui/x-data-grid/locales';


async function enableMocking(enable) {

  if(!enable) return;
  if(process.env.NODE_ENV !== 'development') return;
  
 
  const { worker } = await import('./mock/browser')
 
  // `worker.start()` returns a Promise that resolves
  // once the Service Worker is up and ready to intercept requests.
  return worker.start()
}

const container = document.getElementById('root');
const root = createRoot(container);

export const authService = new AuthService();
const theme = createTheme(
  dateRuRU,
  coreRuRU,
  dataGridRuRU
);

enableMocking(false)
  .then(() => {
    root.render(
        <Provider store={store}>
          <AuthServiceProvider value={authService}>
            <Router
              future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true
              }}
            >
              <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                  <App />
                </ThemeProvider> 
              </StyledEngineProvider>
            </Router>
          </AuthServiceProvider>
        </Provider>  
    );
  });


